import { render, staticRenderFns } from "./BeaconStats.vue?vue&type=template&id=5f437b55"
import script from "./BeaconStats.vue?vue&type=script&lang=js"
export * from "./BeaconStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports